// ─────────────────────────────────────────
// SHARED STYLE CONSTANT
// ic = input class — used by every editable input across the sections
// ─────────────────────────────────────────
export const ic = "w-full rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

// ─────────────────────────────────────────
// DATE HELPERS
// formatDOBInput — auto-inserts slashes as user types (12121990 → 12/12/1990)
// dobToMySQL    — flips MM/DD/YYYY into YYYY-MM-DD before sending to API
// formatDate    — turns a DB date into MM/DD/YYYY for display
// ─────────────────────────────────────────
export function formatDOBInput(value) {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function dobToMySQL(val) {
  if (!val) return null;
  const parts = val.split('/');
  if (parts.length === 3 && parts[2].length === 4) {
    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }
  return val;
}

export function formatDate(val) {
  if (!val) return null;
  const d = new Date(val);
  if (isNaN(d.getTime())) return val;
  return `${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}/${d.getUTCFullYear()}`;
}

// ─────────────────────────────────────────
// EMPTY RECORD FACTORIES
// Used when adding a new property / vehicle / rec unit on the client detail page.
// ─────────────────────────────────────────
export function emptyProperty() {
  return {
    propertyType: 'Primary Home', address: '', titleHolder: '',
    hasMortgage: false, escrowPremium: false,
    mortgageeName: '', mortgageeAddress: '',
    roofYear: '', roofMaterial: '', roofShape: '', roofClassIV: false,
    yearBuilt: '', squareFootage: '', constructionType: '', numFloors: '',
    hasBasement: false, basementType: '', basementSqFt: '',
    hasPool: null,
    centralFireAlarm: false, centralBurglarAlarm: false, lowTempSensor: false,
    sprinklerSystem: false, permanentGenerator: false, gatedCommunity: false, autoWaterShutoff: false,
    waterHeaterYear: '', hvacYear: '', plumbingYear: '', electricalYear: '',
    isVacant: false, isUnderConstruction: false, isForSale: false, isHistoricRegistry: false,
  };
}

export function emptyAuto() {
  return {
    year: '', make: '', model: '', trim: '', vin: '',
    titleHolder: '', primaryDriver: '', ownershipType: 'Owned',
    vehicleType: 'Private Passenger',
    hasCustomEquipment: false, customEquipmentAmount: '',
    keptInGarage: false, registeredInState: false,
    discountABS: false, discountPassiveRestraint: false,
    antitheftVinEtching: false, antitheftVehicleRecovery: false, antitheftDisablingDevice: false,
    agreedValue: '',
  };
}

export function emptyRecUnit() {
  return { unitType: 'Boat', year: '', make: '', model: '', titleHolder: '', primaryDriver: '' };
}

// ─────────────────────────────────────────
// AUTH TOKEN HELPER
// File download URLs and the analyze endpoint need to send the auth token
// directly. Centralized here so we have one source of truth.
// ─────────────────────────────────────────
export function getAuthToken() {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || '';
}